import { useState } from "react";
import { mutate } from "swr";

import { axiosInstance } from "../services/config";
import { MethodType } from "../services/type";

export const MAX_AVATAR_FILE_SIZE = 2 * 1024 * 1024;

export function useUploadProfileImg(userId?: string) {
  const [isUploading, setIsUploading] = useState(false);

  const uploadProfileImg = async (file: File) => {
    if (!userId) return;
    const formData = new FormData();
    formData.append("file", file, file.name);

    setIsUploading(true);
    try {
      await axiosInstance.post(`/mediamanager/userprofile/image`, formData, {
        params: { userId },
        headers: { "Content-Type": "multipart/form-data" },
      });
      await mutate([
        `/mediamanager/userprofile/${userId}/image`,
        MethodType.GET,
      ]);
    } finally {
      setIsUploading(false);
    }
  };

  return { uploadProfileImg, isUploading };
}
